//Url Base
export const baseUrl = document.getElementById('baseFullPath').getAttribute('href');
export const version = document.getElementById('appVersion').value;
export const baseRelUrl = document.getElementById('baseRelativePath').getAttribute('href');
//Controllers
const articuloController = 'API/Articulo';
const service = 'Service';

//Routes
export const ArticuloRoutes = {
    Obtener_Articulos_Activos_vs_Comprados: `${baseUrl}${articuloController}/Obtener_Articulos_Activos_vs_Comprados`,
    Obtener_Estadisticas_Articulos_Calificados: `${baseUrl}${articuloController}/Obtener_Estadisticas_Articulos_Calificados`,
    Obtener_Estadisticas_Articulos_TopN_Abandonados: `${baseUrl}${articuloController}/Obtener_Estadisticas_Articulos_TopN_Abandonados`,
    Obtener_Estadisticas_Articulos_TopN_MejorCalificacion: `${baseUrl}${articuloController}/Obtener_Estadisticas_Articulos_TopN_MejorCalificacion`,
    Obtener_Estadisticas_Articulos_TopN_PeorCalificacion: `${baseUrl}${articuloController}/Obtener_Estadisticas_Articulos_TopN_PeorCalificacion`,
    Obtener_Estadisticas_Articulos_TopN_Ventas: `${baseUrl}${articuloController}/Obtener_Estadisticas_Articulos_TopN_Ventas`
};

export const ServiceRoutes = {
    Socio_Frecuente_Total: `${baseUrl}${service}/Socio_Frecuente_Total`,
    Socio_Frecuente_Total_ActivosNuevo: `${baseUrl}${service}/Socio_Frecuente_Total_ActivosNuevo`,
    Socio_Frecuente_Total_Nuevos: `${baseUrl}${service}/Socio_Frecuente_Total_Nuevos`,
    Total_Contactos_Reclamos: `${baseUrl}${service}/Total_Contactos_Reclamos`,
    Total_Ventas_Por_Dias: `${baseUrl}${service}/Total_Ventas_Por_Dias`
};

//Url Routes for Components
export const SiteRoutes = {
    Cliente: `${baseRelUrl}Cliente`,
    Ordenes: `${baseRelUrl}Ordenes`,
    Articulos: `${baseRelUrl}Articulos`,
    Error: `${baseRelUrl}Error`,
    Base: baseRelUrl
};